import {Component, ElementRef, inject, OnInit, ViewChild, ChangeDetectionStrategy} from '@angular/core';
import { AuthTokenStore } from '../../services/auth-token/auth-token.store';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import {PushserviceService} from "../../services/pushservice/pushservice.service";
import {
  ModalController,
  IonButton,
  IonButtons,
  IonCol,
  IonContent,
  IonDatetime,
  IonFooter,
  IonHeader,
  IonIcon,
  IonInput,
  IonItem,
  IonLabel,
  IonModal,
  IonRow,
  IonToolbar,
  NavController,
  Platform,
} from '@ionic/angular';
import {ApiService} from "../../services/api/api.service";
import {FirebaseStatsService} from "../../services/firebasestats/firebase-stats.service";
import {AmplitudeService} from "../../services/amplitude/amplitude.service";
import {AppsflyerService} from "../../services/services";
import {ActivatedRoute, Router} from "@angular/router";
import moment from "moment";
import { Capacitor } from '@capacitor/core';
import { addIcons } from 'ionicons';
import {chevronBackOutline, closeOutline, eyeOffOutline, eyeOutline, refreshOutline} from 'ionicons/icons';
import {LoaderService} from "../../services/loader/loader.service";
import {ParseErrorService} from "../../services/parse-error/parse-error.service";
import {Team, TeamPickerModalComponent} from "../../components/team-picker-modal/team-picker-modal.component";
import {NativeCredentialManager} from '../../plugins/native-credential-manager';
import {DeepLinkService} from "../../services/deep-link/deep-link.service";

addIcons({
  'chevron-back-outline': chevronBackOutline,
  'close-outline': closeOutline,
  'refresh-outline': refreshOutline,
  'eye-off-outline': eyeOffOutline,
  'eye-outline': eyeOutline,
});

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-registration',
  templateUrl: './registration.page.html',
  styleUrls: ['./registration.page.scss'],
  standalone: true,
  imports: [CommonModule, FormsModule, IonButton, IonButtons, IonCol, IonContent, IonDatetime, IonFooter, IonHeader, IonIcon, IonInput, IonItem, IonLabel, IonModal, IonRow, IonToolbar]
})
export class RegistrationPage  {
  private readonly authTokenStore = inject(AuthTokenStore);
  @ViewChild(IonModal) modal!: IonModal;
  dobOpen = false;
  minDob!: string;
  maxDob!: string;
  totalSteps = [1,2,3,4,5,6,7];
  nowStep = 1;
  account: any = {};
  // testEmail = {email: 'test333@gmail.com'};
  years: number[] = [];
  selectedOpt = '';
  searchListOfAddresses:any = [];
  showAddressSection = false;
  selAddress = [];
  marketingButtonActive = '';
  isManualEdit = false;
  passwordType: string = 'password';
  passwordIcon: string = 'eye-off-outline';
  tempBuilding = '';
  tempStreet = '';
  tempCity = '';
  tempPost = ''
  temp_address_from_loqate = '';


  dobValidated = true;
  PhoneValidated = true;
  addressValidated = true;
  cityValidated = true;
  postcodeValidated = true;
  firstNameValidated = true
  lastNameValidated = true
  usernameValidated = true
  usernameIsTaken = false;
  passwordValidated = true;
  today = new Date();
  minAge = 18;
  showLoader = false;
  selectedTeam?: Team = undefined;
  private readonly firebaseSignUpAbortEvent = Capacitor.getPlatform() === 'ios' ? 'iOS_sign_up_abort' : 'Android_sign_up_aborted';
  private readonly firebaseSignUpFinishedEvent = Capacitor.getPlatform() === 'ios' ? 'iOS_sign_up_complete' : 'Android_sign_up_finished';

  initialDate = new Date(
    this.today.getFullYear() - this.minAge,
    this.today.getMonth(),
    this.today.getDate()
  )
    .toISOString()
    .slice(0, 10);


  maxDate = this.initialDate;
  constructor(
    public navCtrl :NavController,
    public api: ApiService,
    private elRef: ElementRef,
    public pushServ: PushserviceService,
    public firebaseStats: FirebaseStatsService,
    private ampl:AmplitudeService,
    private route: ActivatedRoute,
    private router: Router,
    public appsFlyerServ: AppsflyerService,
    public loader: LoaderService,
    private parseError: ParseErrorService,
    private modalCtrl: ModalController,
    private deepLinkService: DeepLinkService

  ) {
    this.route.queryParams.subscribe(params => {
      console.log('params', params);
      this.account = params;
      // console.log('this.account', this.account);
      this.account = {...this.account };
    });
    // console.log('this.route.snapshot.paramMap', this.route.snapshot.paramMap);

    console.log('this.account', this.account);

    // this.account = this.navParams.get('account');
    // this.account = {...this.testEmail};

    // console.log('this.account', this.account);



    // якщо у тебе старі значення "DD/MM/YYYY" → конвертнемо
    if (this.account.dob && this.account.dob.includes('/')) {
      this.account.dob = this.toIsoFromDdMmYyyy(this.account.dob) ?? null;
    }
    // this.account.tempPostcode = 'WV4 4TR';
    // this.account.email = 'igortest73@gmail.com';
  }

  openDobSheet() {
    this.dobOpen = true;
  }

  onDobPicked(ev: CustomEvent) {
    const iso = (ev.detail as any).value as string | null; // "YYYY-MM-DD" або повний ISO
    this.account.dob = iso ? iso.slice(0, 10) : null;
    this.dobOpen = false;
  }

  get displayDob(): string {
    if (!this.account?.dob) return '';
    const d = new Date(this.account.dob);
    if (isNaN(+d)) return '';
    const dd = String(d.getDate()).padStart(2, '0');
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    const yyyy = d.getFullYear();
    return `${dd}/${mm}/${yyyy}`;
  }

  private toIsoFromDdMmYyyy(d: string): string | null {
    const [dd, mm, yyyy] = d.split('/').map(Number);
    if (!dd || !mm || !yyyy) return null;
    return new Date(yyyy, mm - 1, dd).toISOString().slice(0, 10);
  }

  canDismiss = (_data?: any, role?: string) => {
    return role === 'cancel' || role === 'confirm'; //
  };

  onCancel() {
    this.modalCtrl?.dismiss(null, 'cancel');
  }

  onSave() {
    console.log(123);
    console.log('this.modal', this.modalCtrl);
    this.modalCtrl?.dismiss({ saved: true }, 'confirm');
  }


  hideShowPassword(e) {
    if(this.account.password){
      e.preventDefault();
      // console.log("hideShowPassword");
      const passInput = this.elRef.nativeElement.querySelector('.passwordInput');
      const el2 = passInput.querySelectorAll('input');
      this.passwordType = this.passwordType === 'text' ? 'password' : 'text';
      this.passwordIcon = this.passwordIcon === 'eye-off-outline' ? 'eye-outline' : 'eye-off-outline';
      setTimeout(() => {
        el2[0].focus()
        el2[0].setSelectionRange(this.account.password.length,this.account.password.length);
      },500);
    }
  }

  setCaretPosition(ev) {
    const passInput = this.elRef.nativeElement.querySelector('.passwordInput');
    const el2 = passInput.querySelectorAll('input');
    if(this.account.password){
      el2[0].setSelectionRange(this.account.password.length,this.account.password.length);
    }
  }

  marketingTimeout;
  saveMarketingAction(str:string) {
    this.marketingButtonActive = str;
    setTimeout(() => {
      this.account.marketing_opt_in = (str === 'yes');
      // console.log('this.account.marketing_opt_in', this.account.marketing_opt_in);
      clearTimeout(this.marketingTimeout);
    },300)
  }

  ionViewDidLoad() {

  }

  goToWelcomePage() {
    this.pushServ.sendInAppTrigger('signup_incomplete','true');
    const screens = ['dob_screen','phone_screen','postcode_screen','name_screen','username_screen','password_screen']
    const abortPages = ['dob_screen','phone_screen','postcode_screen','name_screen','username_screen', 'password_screen']
    this.firebaseStats.sendEvent(this.firebaseSignUpAbortEvent, {screen_name: screens[this.nowStep-1]});
    this.appsFlyerServ.sendLogEvent('af_sign_up_abort', {stage_name: abortPages[this.nowStep-1]});
    this.nowStep = 1;
    this.showAddressSection = false;
    this.searchListOfAddresses = [];
    this.isManualEdit = false;

    // console.log('this.account', this.account);
    //AMPLITUDE EVENT
    // Only the step: no personal data in analytics events (MBP-3128).
    const abortDetail = {
      aborted_stage: this.nowStep
    };
    // console.log('abortDetail', abortDetail);
    this.ampl.trackEvent('sign_up_abort', abortDetail)
    // this.navCtrl.push('WelcomePage');
    this.router.navigate(['welcome']);
  }

  goBack() {
    this.nowStep = this.nowStep - 1;
  }


  backToStartSearchPostcode(){
    this.showAddressSection = false;
    delete this.account.building;
    delete this.account.street;
    delete this.account.city;
    delete this.account.postcode;
  }

  switchToManualEdit() {
    this.isManualEdit = !this.isManualEdit;
    if(this.isManualEdit){
      this.tempBuilding = this.account.building;
      this.tempStreet = this.account.street;
      this.tempCity = this.account.city;
      this.tempPost = this.account.postcode;
    }else {
      this.account.building = this.tempBuilding
      this.account.street = this.tempStreet
      this.account.city = this.tempCity
      this.account.postcode = this.tempPost
    }
  }

  async goNextStep() {
    console.log('this.account', this.account);
    console.log('this.nowStep', this.nowStep);
    switch (this.nowStep) {
      case  1:
      case  2:
      case  3:
      case  4:
        this.nowStep = this.nowStep + 1;
        console.log('this.account', this.account);
        break;
      case  5:
        if (this.account.username) {
          const usernameCheck = await this.checkUsernameTaken();
          if(usernameCheck){
            this.usernameIsTaken = true;
            this.usernameValidated = false;
            return false;
          }else {
            this.usernameIsTaken = false;
          }
        }
        this.usernameValidated = true;
        this.nowStep = this.nowStep + 1;
        break;
      case  6:
        console.log('this.account', this.account);
        this.nowStep = this.nowStep + 1;
        break;
      default:
        this.registerUserOnTheServer();
        break;
    }

    return true
  }

  searchPostcodeTimeout;
  searchPostcode() {

    console.log('searchPostcode');
    if(this.account.tempPostcode != '' && this.account.tempPostcode.length < 5){
      return false;
    }

    if(this.account.tempPostcode == ''){
      clearTimeout(this.searchPostcodeTimeout);
      this.searchListOfAddresses = [];
      return false;
    }

    clearTimeout(this.searchPostcodeTimeout);
    this.searchPostcodeTimeout = setTimeout(() => {
      this.showLoader = true;
      this.api.findByPostcode(this.account.tempPostcode).subscribe(async (postcodeRes) => {
        this.searchListOfAddresses = postcodeRes.data.addresses;
        this.showLoader = false;
      }, (err) => {
        this.showLoader = false;
      });
    }, 1000);

    return true
  }

  selectAddress(address:any) {
    // console.log('address', address);
    this.showAddressSection = true;
    this.temp_address_from_loqate = ([address.building+', '+address.street, address.town, address.postcode].join(',<br>'));
    // console.log('this.temp_address_from_loqate', this.temp_address_from_loqate);
    this.account.building = address.building;
    this.account.street = address.street;
    this.account.city = address.town;
    this.account.postcode = address.postcode


  }


  async checkUsernameTaken() {
    return new Promise(resolve => {
      this.api.signUpCheck(this.account.username).subscribe(async (res) => {
        if(res.apiCode == 'SUCCESS' && res.apiStatus == 'OK'){
          resolve(res.data.result);
        }
      });
    })
  }


  registerUserOnTheServer(isMyTeamSkip = false) {

    this.loader.show();
    try {
      if(isMyTeamSkip){
        this.selectedTeam = undefined;
      }
      this.account.dob = moment(this.account.dob).format('DD/MM/YYYY');
      this.selectedTeam ? this.account.my_team_id = this.selectedTeam.id : delete this.account.my_team_id;
      delete this.account.tempPostcode;
      console.log('this.account', this.account);


      this.api.registerUser(this.account).subscribe(async (res) => {
        if(res.apiCode == 'SUCCESS' && res.apiStatus == 'OK'){
          // console.log('res', res);
          const user = res.data.user;
          console.log('user', user);
          // No name or age in analytics events (MBP-3128).
          const dataForAmplitude = {
            user_id: user.id,
            kyc_status: user.KYC
          };
          //AMPLITUDE
          this.ampl.setUserId(user.id);
          // this.ampl.initAmplitude(user.id)
          if(user.KYC == 'pass'){
            this.pushServ.sendInAppTrigger('registration_complete','true');
          }

          void this.authTokenStore.setToken(user.token);
          localStorage.setItem('userCreatedAt', user.created_at);
          localStorage.setItem('partnerId', user.partner_id);

          //Firebase
          this.firebaseStats.sendEvent(this.firebaseSignUpFinishedEvent, {});

          //Appsflyer event
          // this.appsFlyerServ.sendLogEvent('af_complete_registration');
          this.appsFlyerServ.setUserId(user.id);
          this.appsFlyerServ.sendAppsFlyerUIDToServer(user.token);

          //Apmlitude
          // setTimeout(() => {
          this.ampl.trackEvent('sign_up_complete', dataForAmplitude)
          // },1000)

          // Setup OneSignal Notifications
          this.pushServ.setupPush(user)
          localStorage.setItem('openTopUp', 'true');
          await this.saveRegistrationCredential();
          // this.navCtrl.setRoot(MainPage);
          const resumedDeepLink = await this.deepLinkService.resumePending();
          if (!resumedDeepLink) {
            this.router.navigate(['/tabs/games']);
          }
          this.resetRegistrationState();
        }
        this.loader.hide();
      }, async (err: any) => {
        this.loader.hide();
        this.parseError.showError(err);
      });
    }finally {

    }

  }

  private async saveRegistrationCredential(): Promise<void> {
    if (
      Capacitor.getPlatform() !== 'android' ||
      !this.account.email ||
      !this.account.password
    ) {
      return;
    }

    try {
      await NativeCredentialManager.savePassword({
        username: this.account.email.trim(),
        password: this.account.password
      });
    } catch {
      // Saving credentials is optional and must not block registration.
    }
  }

  private resetRegistrationState(): void {
    this.nowStep = 1;
    this.account = {};
    this.selectedTeam = undefined;
    this.selectedOpt = '';

    this.dobOpen = false;
    this.searchListOfAddresses = [];
    this.showAddressSection = false;
    this.selAddress = [];
    this.isManualEdit = false;
    this.marketingButtonActive = '';

    this.tempBuilding = '';
    this.tempStreet = '';
    this.tempCity = '';
    this.tempPost = '';
    this.temp_address_from_loqate = '';

    this.dobValidated = true;
    this.PhoneValidated = true;
    this.addressValidated = true;
    this.cityValidated = true;
    this.postcodeValidated = true;
    this.firstNameValidated = true;
    this.lastNameValidated = true;
    this.usernameValidated = true;
    this.usernameIsTaken = false;
    this.passwordValidated = true;

    this.passwordType = 'password';
    this.passwordIcon = 'eye-off-outline';
    this.showLoader = false;
  }

  isUser18(birthDateStr) {
    const [year,month, day] = birthDateStr.split('-').map(Number);
    const birthDate = new Date(year, month - 1, day); // JS місяці 0-11, тому віднімаємо 1
    const today = new Date();
    const eighteenYearsLater = new Date(birthDate);
    eighteenYearsLater.setFullYear(eighteenYearsLater.getFullYear() + 18);
    return today >= eighteenYearsLater;
  }

  disableNextButton() {
    switch (this.nowStep) {
      case  1:
        if (!this.account.dob || this.account.marketing_opt_in == undefined) {
          return true;
        }

        if(!this.isUser18(this.account.dob)){
          return true;
        }
        break;
      case  2:
        // console.log('!this.account.phone || this.account.phone.length !== 11', !this.account.phone || this.account.phone.length !== 11);
        // console.log('!isNaN(this.account.phone)', !isNaN(this.account.phone));
        if (!this.account.phone || this.account.phone.toString().length !== 11) {
          // console.log('this.account.phone', this.account.phone);
          // console.log('this.account.phone.length !== 11', this.account.phone.length !== 11);
          return true;
        }
        if(isNaN(this.account.phone)){
          console.log('isNaN(this.account.phone)');
          return true;
        }
        break;
      case  3:
        if(!this.account.building || this.account.building == '' || this.account.building.trim().length == 0){
          return true;
        }
        if(!this.account.street || this.account.street == '' || this.account.street.trim().length == 0){
          return true;
        }
        if(!this.account.city || this.account.city == '' || this.account.city.trim().length == 0){
          return true;
        }
        if(!this.account.postcode || this.account.postcode == '' || this.account.postcode.trim().length == 0){
          return true;
        }
        break;
      case  4:
        if (!this.account.first_name || this.account.first_name.length < 3) {
          return true;
        }
        if (!this.account.last_name || this.account.last_name.length < 3) {
          return true;
        }

        if(this.account.first_name){
          const res = this.account.first_name.match(/^[a-zA-Z][a-zA-Z'\- ]*[a-zA-Z]\s*$/)
          // console.log('checkRes', res);
          if(!res){
            return true
          }
        }
        if(this.account.last_name){
          const res = this.account.last_name.match(/^[a-zA-Z][a-zA-Z'\- ]*[a-zA-Z]\s*$/)
          // console.log('checkRes', res);
          if(!res){
            return true
          }
        }
        this.account.first_name = this.account.first_name.trim();
        this.account.last_name = this.account.last_name.trim();
        break;
      case  5:
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!this.account.username || this.account.username.length < 3 || this.account.username.toLowerCase() == this.account.email.toLowerCase() || emailRegex.test(this.account.username)) {
          return true;
        }
        if(this.account.username){
          const name = this.account.username.split(' ');
          if(name.length > 1){
            return true;
          }
        }
        break;
      case  6:
        if(!this.account.password){
          return true;
        }
        // const res = this.account.password.match(/^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])([a-zA-Z0-9]{8,})$/); //my
        // At least 10 characters (pen test MBP-2969, enforced by the server too) with an upper- and lower-case letter and a number.
        const res = this.account.password.match(/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z]).{10,}$/);
        // console.log('checkRes', res);
        if(!res){
          this.passwordValidated = false;
          return true;
        }
        break;
      default:
        if(!this.selectedTeam){
          return true;
        }
        break;
    }

    return false;
  }

  onPhoneInput(event: any) {
    const cleaned = (event.detail?.value || '').replace(/\D/g,'');
    this.account.phone = cleaned;  // модель
    event.target.value = cleaned;
  }

  ionViewWillLeave() {
    this.onCancel();
  }

  async openTeamPicker() {
    const mod = await this.modalCtrl.create({
      component: TeamPickerModalComponent,
      componentProps: { selectedId: this.selectedTeam?.id ?? null },
      initialBreakpoint: 0.9,
      handle: false,
      cssClass: 'team-picker-sheet',
    });
    await mod.present();

    const { data } = await mod.onWillDismiss<{ team?: Team }>();
    console.log('data', data);
    if (data?.team) this.selectedTeam = data.team;
  }

  protected readonly JSON = JSON;
}
